/* eslint-disable */
export default {
  _counting_fish_00: 'counting_fish-00',
  _counting_fish_01: 'counting_fish-01',
  _counting_fish_03: 'counting_fish-03',
  _counting_fish_04: 'counting_fish-04',
  _counting_fish_05: 'counting_fish-05',
  _counting_fish_06: 'counting_fish-06',
  _counting_fish_07: 'counting_fish-07',
  _counting_fish_09: 'counting_fish-09',
  _counting_fish_10: 'counting_fish-10',
  _counting_fish_11: 'counting_fish-11',
  _counting_fish_12: 'counting_fish-12',
  _counting_fish_13: 'counting_fish-13',
  _counting_fish_14: 'counting_fish-14',
  _counting_fish_15: 'counting_fish-15',
  _Sound1: 'Sound1',
  _Sound10: 'Sound10',
  _Sound11: 'Sound11',
  _Sound12: 'Sound12',
  _Sound13: 'Sound13',
  _Sound14: 'Sound14',
  _Sound15: 'Sound15',
  _Sound16: 'Sound16',
  _Sound17: 'Sound17',
  _Sound18: 'Sound18',
  _Sound19: 'Sound19',
  _Sound2: 'Sound2',
  _Sound20: 'Sound20',
  _Sound3: 'Sound3',
  _Sound4: 'Sound4',
  _Sound5: 'Sound5',
  _Sound6: 'Sound6',
  _Sound7: 'Sound7',
  _Sound8: 'Sound8',
  _Sound9: 'Sound9',
}